// components/academy/LearnThisFeature.tsx
// Floating "Learn This Feature" button that opens R2 Academy
import { useState, type JSX } from 'react';
import { GraduationCap } from 'lucide-react';

interface LearnThisFeatureProps {
  courseId?: string;
  label?: string;
  position?: 'top-right' | 'bottom-right' | 'inline';
}

export function LearnThisFeature({ courseId, label = 'Learn This Feature', position = 'top-right' }: LearnThisFeatureProps): JSX.Element {
  const [hov, setHov] = useState(false);

  const handleClick = () => {
    window.dispatchEvent(new CustomEvent('r2-navigate', { detail: { route: 'r2-academy' } }));
  };

  const positionStyles = position === 'inline' ? {} : {
    position: 'fixed' as const,
    top: position === 'top-right' ? 72 : 'auto',
    bottom: position === 'bottom-right' ? 80 : 'auto',
    right: 20,
    zIndex: 500,
  };

  return (
    <button
      data-testid="learn-this-feature-btn"
      onClick={handleClick}
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        ...positionStyles,
        display: 'flex',
        alignItems: 'center',
        gap: 7,
        padding: hov ? '7px 14px' : '7px 12px',
        background: hov ? 'rgba(0,212,255,0.12)' : 'rgba(0,212,255,0.06)',
        border: `1px solid ${hov ? 'rgba(0,212,255,0.5)' : 'rgba(0,212,255,0.2)'}`,
        borderRadius: 20,
        cursor: 'pointer',
        transition: 'all 0.2s',
        backdropFilter: 'blur(8px)',
      }}
    >
      <GraduationCap size={12} style={{ color: '#00d4ff', flexShrink: 0 }}/>
      <span style={{
        fontFamily: "'JetBrains Mono','Space Mono',monospace",
        fontSize: 10,
        fontWeight: 700,
        color: '#00d4ff',
        letterSpacing: '0.06em',
        whiteSpace: 'nowrap',
        maxWidth: hov ? 140 : 0,
        overflow: 'hidden',
        transition: 'max-width 0.2s ease',
      }}>{label}</span>
    </button>
  );
}
